module.exports = __webpack_public_path__ + "static/img/bio.fd57ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/desktop/bio.png
// module id = C0jm
// module chunks = 0